export default "__VITE_ASSET__efcbf7b9__"